angular.module('components.caNewContactInfoForm', [])
    .component('caNewContactInfoForm', {
        templateUrl: 'main/contacts/components/newcontactinfoform.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            contactInfoTypes: '<',
            onContactInfoCreated: '&'
        },
        controller: controller
    });

// @ngInject
function controller() {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.createContactInfo = createContactInfo;

    vm.selectedContactInfoType = {};

    function onInit() {
        if (vm.contactInfoTypes.length !== 0) {
            vm.selectedContactInfoType = vm.contactInfoTypes[0];
        }
    }
    function onChanges(changes) {
    }
    function onDestroy() {
    }

    function createContactInfo() {
        var newContactInfo = {
            contactInfoType: vm.selectedContactInfoType,
            value: ''
        };

        vm.onContactInfoCreated({contactInfo: newContactInfo});
    }
}
